import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";
import protocolMdV01 from "../protocols/v0.1/protocol.md";
import protocolMdV02 from "../protocols/v0.2/protocol.md";
import protocolPdfV01 from "../protocols/v0.1/protocol.pdf";
import protocolPdfV02 from "../protocols/v0.2/protocol.pdf";
import { Link } from "react-router-dom";

function Navigation() {
  return (
    <nav className="main-nav">
      <Link to="/" className="nav-link">Home</Link>
      <Link to="/about" className="nav-link">About</Link>
      <Link to="/protocol/v0.2" className="nav-link">Protocol</Link>
    </nav>
  );
}

function Protocol({ version }) {
  const [protocolContent, setProtocolContent] = useState("");

  useEffect(() => {
    document.title = `wCross Protocol ${version}`;

    const protocolFile = version === "v0.1" ? protocolMdV01 : protocolMdV02;
    fetch(protocolFile)
      .then((res) => res.text())
      .then((text) => setProtocolContent(text))
      .catch((err) => console.error("Failed to load markdown file:", err));
  }, [version]);

  return (
    <div className="App">
      <header className="App-header">
        <Navigation />
        <h1>wCross Protocol {version}</h1>
        <div className="protocol-actions">
          <a href="https://github.com/wcrossorg"
             target="_blank"
             rel="noopener noreferrer"
             className="github-link"
          >
            GitHub
          </a>
          <a href={version === "v0.1" ? protocolPdfV01 : protocolPdfV02}
             download={`wcross-protocol-${version}.pdf`}
             className="pdf-download-link"
          >
            Download PDF
          </a>
        </div>
        <div className="protocol-content">
          <ReactMarkdown
            remarkPlugins={[remarkGfm, remarkMath]}
            rehypePlugins={[rehypeKatex]}
          >
            {protocolContent}
          </ReactMarkdown>
        </div>
      </header>
    </div>
  );
}

export default Protocol; 